import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { DigestionEditForm } from "./components/DigestionEditForm";

export function EditDigestionPage() {
  return (
    <LqsPage title="Edit Digestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionEditForm />
      </Container>
    </LqsPage>
  );
}
